import React, { useState, useEffect, useContext, Fragment } from "react";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ModalPop from "components/sales/modal/modal";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { toast } from "react-toastify";

const AdvanceSalary = ({
    advanceSalaryListingRequest,
    advanceSalaryListResponse = {},
    advanceSalaryCalculateRequest,
    advanceSalaryCalculateResponse = {},
    advanceSalaryUpdateRequest,
    advanceSalaryUpdateResponse = {}
}) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [approveModal, setApproveModal] = useState(false);
    const [rejectModal, setRejectModal] = useState(false);
    const [finalSalary, setFinalSalary] = useState(0.00);
    const [advanceRequestId, setAdvanceRequestId] = useState(0);

    // read filter from localStorage if applied
    const localData = localStorage.getItem("applyFilter");
    let current_status = "PENDING";
    const validStatus = ["PENDING", "PROCESSED", "REJECTED"];

    const current_filter = JSON.parse(localData || "{}");
    if (current_filter?.status && validStatus.includes(current_filter.status)) {
        current_status = current_filter.status;
    }

    const Headers = [
        "User ID",
        "User Name",
        "Phone Number",
        "Monthly Salary ID",
        "Requested Amount",
        "Remark",
        "Status",
        "Request Date",
        "Reject",
        "Approve"
    ];

    // Initial fetch
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            await advanceSalaryListingRequest(1);
            setIsLoading(false);
        };
        fetchData();
    }, [advanceSalaryListingRequest]);


    // Handle response and map to table data
    useEffect(() => {
        const tableKeys = [
            "id",
            "user_id",
            "name",
            "phone_number",
            "monthly_salary_id",
            "requested_amount",
            "remarks",
            "status",
            "transaction_date",
            "reject_advance_request",
            "approve_advance_request",
        ];

        setListData([]);

        if (advanceSalaryListResponse && advanceSalaryListResponse.data) {
            const data = advanceSalaryListResponse.data.map((element) => {
                return Object.assign(
                    ...tableKeys.map((key) => {
                        if (key === "transaction_date" && element[key]) {
                            const date = new Date(element[key]);
                            const formatted =
                                ("0" + date.getDate()).slice(-2) + "-" +
                                ("0" + (date.getMonth() + 1)).slice(-2) + "-" +
                                date.getFullYear();
                            return { [key]: formatted };
                        }
                        return { [key]: element[key] };
                    })
                );
            });

            data && setListData(data);

            // Pagination calculation
            setPageCount(
                Math.ceil(
                    (advanceSalaryListResponse.total || 0) /
                    (advanceSalaryListResponse.per_page || 1)
                )
            );
        }
    }, [advanceSalaryListResponse]);


    // Toggle filter popup
    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    // Apply filter
    //   const applyFilter = async (filterData) => {
    //     setIsLoading(true);
    //     setFilterData(filterData);
    //     await advanceSalaryListingRequest(1, , filterData?.status);
    //     setIsLoading(false);
    //     filterToggle();
    //   };

    // Header buttons
    // const headerBtns = () => {
    //     return (
    //         <Fragment>
    //             <Button
    //                 onClick={filterToggle}
    //                 className="filter-hamburger btn btn-transparent"
    //             >
    //                 <img src={Images?.Filter} alt="" />
    //                 {localization.showFilters}
    //             </Button>
    //         </Fragment>
    //     );
    // };

    // Handle pagination
    const onPageChange = async (val) => {
        setIsLoading(true);
        if (filterData && filterData.status) {
            await advanceSalaryListingRequest(
                val.selected + 1
            );
        } else {
            await advanceSalaryListingRequest(val.selected + 1);
        }
        setIsLoading(false);
    };

    const handleApproveAdvanceRequest = async (userId, id) => {
        setIsLoading(true);
        setAdvanceRequestId(id)
        const payload = {
            user_id: userId
        };

        try {
            const res = await advanceSalaryCalculateRequest(payload);
            if(res?.status == 0 && res.status_code !== 500){
                setApproveModal(true);
            } 
        } catch (error) {
            console.error("Error calculating advance request:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRejectAdvanceRequest = async (id) => {
        setRejectModal(true);
        setAdvanceRequestId(id)
    };

    const handleRejectModalClose = () => {
        setRejectModal(false);
    }

    const handleApproveModalClose = () => {
        setApproveModal(false);
    }

    const handleSubmitReject = async () => {
        setRejectModal(false);
        setIsLoading(true);
        const payload = {
            status: "REJECTED",
            advance_salary_request_id: advanceRequestId,
            approved_amount: null
        };

        try {
            const res = await advanceSalaryUpdateRequest(payload);
            if(res?.status == 0 && res.status_code !== 500){
                toast.success("Request rejected successfully")
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } 
        } catch (error) {
            console.error("Error approving advance request:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmitApprove = async () => {
        setApproveModal(false);
        setIsLoading(true);

        if(advanceSalaryCalculateResponse && advanceSalaryCalculateResponse !== undefined && advanceSalaryCalculateResponse?.data && advanceSalaryCalculateResponse?.data !== undefined && advanceSalaryCalculateResponse?.data?.monthly_salary && advanceSalaryCalculateResponse?.data?.monthly_salary !== undefined && advanceSalaryCalculateResponse?.data?.monthly_salary?.calculated_salary && advanceSalaryCalculateResponse?.data?.monthly_salary?.calculated_salary !== undefined) {

            if(advanceSalaryCalculateResponse?.data?.monthly_salary?.calculated_salary <= finalSalary) {
                setIsLoading(false);
                toast.error("Final amount can't be greater than the calculated amount.");
                return false;
            }
            const payload = {
                status: "APPROVED",
                advance_salary_request_id: advanceRequestId,
                approved_amount: finalSalary
            };
    
            try {
                const res = await advanceSalaryUpdateRequest(payload);
                if(res?.status == 0 && res.status_code !== 500){
                    toast.success("Request approved successfully")
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            } catch (error) {
                console.error("Error approving advance request:", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <Layout
            title={localization.advanceSalary}
            // Buttons={headerBtns}
            className={false ? "requiredFileds" : ""}
            isLoading={isLoading}
        >
        <TableSection
            data={listData}
            headers={Headers}
            pageCount={pageCount}
            onPageChange={onPageChange}
            srNo={advanceSalaryListResponse?.from}
            isId={false}
            handleApproveAdvanceRequest={handleApproveAdvanceRequest}
            handleRejectAdvanceRequest={handleRejectAdvanceRequest}
        />
        {/* reject modal starts */}
        <ModalPop
            title={localization.conf}
            show={rejectModal}
            handleModalHide={handleRejectModalClose}
            keyboard
            backdrop
        >
            <div className="text-center">
                <img src={Images?.ConfirmationIcon} width={"15%"} alt="" />
                <h4>
                    {`Are you sure you want to reject this advance request?`}
                </h4>
            </div>
            <div className="col-md-12 d-flex mt-5" style={{justifyContent: "space-between"}}>
                <div>
                    <Button
                        className="btn btn-danger"
                        onClick={handleRejectModalClose}
                    >
                        No
                    </Button>
                </div>
                <div>
                    <Button className="btn btn-success" onClick={handleSubmitReject}>
                        Yes
                    </Button>
                </div>
            </div>
        </ModalPop>
        {/* reject modal ends */}

        {/* approve modal starts */}
        <ModalPop
            title={'Calculate Advance Salary'}
            show={approveModal}
            handleModalHide={handleApproveModalClose}
            keyboard
            backdrop
        >
            <div className="text-center">
                <div className="row">
                    <div className="col-md-6">
                        <ConstantInput
                            label={'Calculated Salary'}
                            type="text"
                            required
                            isStarRequired={true}
                            value={advanceSalaryCalculateResponse?.data?.monthly_salary?.calculated_salary ?? 0.00}
                            disabled={true}
                        />
                    </div>
                    <div className="col-md-6">
                        <ConstantInput
                        label={'Final Salary'}
                        type="number"
                        required
                        isStarRequired={true}
                        handleChange={(val) => {
                            setFinalSalary(val);
                        }}
                        />
                    </div>
                </div>
                <div className="col-md-12 d-flex mt-5" style={{justifyContent: "flex-end"}}>
                    <div>
                        <Button className="btn btn-success" onClick={handleSubmitApprove} disabled={finalSalary == 0.00}>
                            Approve
                        </Button>
                    </div>
                </div>
            </div>
        </ModalPop>
        {/* reject modal ends */}
        </Layout>
    );
};

export default AdvanceSalary;
